import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

/** code for LightTooltip style */
export const LightTooltip = withStyles(theme => ({
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		fontSize: 12
	}
}))(Tooltip);

/** code for default style */
const useDefaultStyles = makeStyles(theme => ({
	arrow: {
		color: theme.palette.common.black
	},
	tooltip: {
		backgroundColor: theme.palette.common.black,
		fontSize: 12,
		maxWidth: 650
	}
}));

/** code for dark theme style */
const useDarkStyles = makeStyles(theme => ({
	arrow: {
		color: theme.palette.common.white
	},
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0)",
		fontSize: 12,
		maxWidth: 650
	}
}));

/** set theme to dark mode */
export function DarkTooltip(props) {
	const classes =
		localStorage.getItem("data-theme") === "Dark"
			? useDarkStyles()
			: useDefaultStyles();
	return <Tooltip arrow classes={classes} {...props} />;
}

/** Html tool tip for styles */
export const HtmlTooltip = withStyles(theme => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		maxWidth: 220,
		fontSize: theme.typography.pxToRem(12),
		border: "1px solid #dadde9"
	}
}))(Tooltip);
